import { render, staticRenderFns } from "./GlossaryIcon.vue?vue&type=template&id=7267e9a4&scoped=true&"
var script = {}
import style0 from "./GlossaryIcon.vue?vue&type=style&index=0&id=7267e9a4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../college-and-career-public/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7267e9a4",
  null
  
)

export default component.exports